import { render, staticRenderFns } from "./comp-sign.vue?vue&type=template&id=ba7c8012&scoped=true&"
import script from "./comp-sign.vue?vue&type=script&lang=js&"
export * from "./comp-sign.vue?vue&type=script&lang=js&"
import style0 from "./comp-sign.vue?vue&type=style&index=0&id=ba7c8012&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba7c8012",
  null
  
)

export default component.exports